import React, { useRef, useState } from 'react'
import {langs, loadLanguage} from '../../i18n'
import { IoIosArrowDown } from 'react-icons/io'
import US from 'country-flag-icons/react/3x2/US'
import GB from 'country-flag-icons/react/3x2/GB'
import IT from 'country-flag-icons/react/3x2/IT'
import FR from 'country-flag-icons/react/3x2/FR'
import DE from 'country-flag-icons/react/3x2/DE'
import PL from 'country-flag-icons/react/3x2/PL'
import ES from 'country-flag-icons/react/3x2/ES'

export const SelectLanguage = () => {
  const [selectedLanguage, setSelectedLanguage] = useState(localStorage.getItem('language') || 'EN')
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)

  const handleLanguageChange = (lang: string) => {
    setSelectedLanguage(lang)
    localStorage.setItem('language', lang)
    loadLanguage(lang.toLowerCase())
    // changeInterfaceLang(lang.toLowerCase())
    setIsOpen(false)
  }

  const availableLanguages = [
    {name: 'English', icon: GB, code: 'en'},
    {name: 'Italian', icon: IT, code: 'it'},
    {name: 'Français', icon: FR, code: 'fr'},
    {name: 'Deutsch', icon: DE, code: 'de'},
    {name: 'Polski', icon: PL, code: 'pl'},
    {name: 'Español', icon: ES, code: 'es'},
  ]

  const flagsIcons = {
    en: <GB/>,
    it: <IT/>,
    fr: <FR/>,
    de: <DE/>,
    pl: <PL />,
    es: <ES />
  }

  return (
    <div>
      <div className='language-wrapper' ref={dropdownRef} onClick={() => setIsOpen(!isOpen)}>
        <div className='flex items-center'>
          <div className='selected-language'>
            {flagsIcons[selectedLanguage]}
          </div>
          <IoIosArrowDown className={`vector ${isOpen ? 'open' : ''}`} />
        </div>
        {isOpen && (
          <ul className='dropdown'>
            {availableLanguages.map((lang, i) => {
              const IconLang = lang.icon
              return (
              <li 
                key={i} 
                className={`dropdown-item ${lang.code === selectedLanguage ? 'selected' : ''}`}
                onClick={() => handleLanguageChange(lang.code)}
              >
               <IconLang/> 
               <span>{lang.name}</span>
              </li>
            )})}
          </ul>
        )}
      </div>
    </div>
  )
}
